import { CSSProperties, useContext } from 'react';
import GlobalContext from 'contexts/GlobalContext';
import { useTableSelector } from 'hooks/useTableSelector';

import { CashierContext } from 'components/Cashier/CashierContext';
import GameModal, {
  btnRowStyle,
  primaryBtnStyle,
  secondaryBtnStyle
} from 'components/GameModal/GameModal';

const messageStyle: CSSProperties = {
  fontSize: '0.85rem',
  color: 'rgba(255, 255, 255, 0.6)',
  lineHeight: 1.5,
  textAlign: 'center'
};

const AddFundsModal = () => {
  const { openAddFunds, setOpenAddFunds } = useContext(GlobalContext);
  const { openCashier } = useContext(CashierContext);
  const addFundsMsg = useTableSelector((table) => table.game.addFundsMsg);

  // Open the in-app Cashier on the Deposit tab (overlays this modal at a higher
  // z-index) instead of opening the external account site in a new tab. The
  // external tab has no game session, so it landed on the login page; the in-app
  // cashier keeps the player's active session. We leave this modal mounted so the
  // player returns to it if they close the cashier without depositing.
  const handleAddFunds = () => openCashier('deposit');

  const standUp = () => {
    setOpenAddFunds(false);
  };

  const exitTable = () => {
    setOpenAddFunds(false);
    setTimeout(() => window.close(), 100);
  };

  return (
    <GameModal open={openAddFunds} onClose={standUp} title='Add Funds'>
      <div style={messageStyle}>{addFundsMsg}</div>

      <div style={{ ...btnRowStyle, flexWrap: 'wrap' as const }}>
        <button style={secondaryBtnStyle} onClick={exitTable}>
          Exit Table
        </button>
        <button style={primaryBtnStyle} onClick={handleAddFunds}>
          Go to Cashier
        </button>
        {/* <button style={secondaryBtnStyle} onClick={standUp}>
          Observe
        </button> */}
      </div>
    </GameModal>
  );
};

export default AddFundsModal;
